import React from 'react';

import { Spacer as SpacerElement } from '@repo/ui/components/Spacer';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';

const Spacer = ({ slice }) => {
  return (
    <ContentWrapper className="spacer" slice={slice}>
      <SpacerElement height={slice.primary.height} />
    </ContentWrapper>
  );
};

export default Spacer;
